import React, { useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';

const POSITIONS = [
  { value: 'sns-creative', label: 'SNSクリエイティブ担当' },
  { value: 'seo-writer', label: 'SEO記事ライター（準備中）', disabled: true },
  { value: 'ad-creative', label: '広告クリエイティブデザイナー（準備中）', disabled: true },
  { value: 'cs-support', label: 'カスタマーサポート（準備中）', disabled: true },
];

const HOURS_OPTIONS = [
  '週10時間程度',
  '週15時間程度',
  '週20時間程度',
  '週25時間程度',
  '週30時間以上',
];

const START_OPTIONS = [
  '即日可能',
  '2週間以内',
  '1ヶ月以内',
  '相談したい',
];

const REFERRAL_OPTIONS = [
  'Indeed',
  'Wantedly',
  'engage',
  'X（旧Twitter）',
  'Google検索',
  '知人の紹介',
  'その他',
];

const PREFECTURES = [
  '北海道','青森県','岩手県','宮城県','秋田県','山形県','福島県',
  '茨城県','栃木県','群馬県','埼玉県','千葉県','東京都','神奈川県',
  '新潟県','富山県','石川県','福井県','山梨県','長野県',
  '岐阜県','静岡県','愛知県','三重県',
  '滋賀県','京都府','大阪府','兵庫県','奈良県','和歌山県',
  '鳥取県','島根県','岡山県','広島県','山口県',
  '徳島県','香川県','愛媛県','高知県',
  '福岡県','佐賀県','長崎県','熊本県','大分県','宮崎県','鹿児島県','沖縄県',
  '海外'
];

// GAS Web App URL — デプロイ後に差し替え
const GAS_ENDPOINT = 'https://script.google.com/macros/s/AKfycbwR4Mzv2wYR-ygoWh2eLQZf4ia57GBtidXBAVZeR2_pg4IFVOR2dnhI-mukRQZRkaXB3Q/exec';

function RecruitApplyPage() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    position: '',
    introduction: '',
    portfolio1: '',
    portfolio2: '',
    portfolio3: '',
    hoursPerWeek: '',
    startTiming: '',
    prefecture: '',
    referral: '',
    note: '',
  });
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setError('');

    try {
      if (GAS_ENDPOINT) {
        await fetch(GAS_ENDPOINT, {
          method: 'POST',
          mode: 'no-cors',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            ...formData,
            submittedAt: new Date().toISOString(),
          }),
        });
      }
      setSubmitted(true);
    } catch (err) {
      setError('送信中にエラーが発生しました。お手数ですが、しばらくしてから再度お試しください。');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="contact-page">
      {/* Page Header */}
      <section className="page-header">
        <Container>
          <h1 className="page-title">Entry</h1>
          <p className="page-subtitle">採用エントリー</p>
        </Container>
      </section>

      {/* Introduction */}
      <section className="section-contact-before">
        <Container>
          <Row className="justify-content-center">
            <Col lg={8}>
              <div className="before-content">
                <h3>ご応募ありがとうございます</h3>
                <p>
                  以下のフォームに必要事項をご記入ください。<br />
                  書類選考の結果は、通過された方にのみメールでご連絡いたします。
                </p>
                <p style={{ fontSize: '13px', color: 'var(--text-tertiary)', marginTop: '1.5em' }}>
                  ※ ポートフォリオ（過去の制作物）は選考において非常に重要です。<br />
                  　 SNS投稿画像、動画、Webサイトなど、ご自身の制作実績がわかるURLをご記入ください。
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Form */}
      <section className="section-contact-form">
        <Container>
          <Row className="justify-content-center">
            <Col lg={8}>
              {submitted ? (
                <div style={{ textAlign: 'center', padding: '60px 0' }}>
                  <h3 style={{ fontSize: '1.4rem', fontWeight: 300, color: 'var(--text-primary)', marginBottom: '16px' }}>
                    エントリーを受け付けました。
                  </h3>
                  <p style={{ fontSize: '14px', color: 'var(--text-secondary)', lineHeight: 2 }}>
                    書類選考の結果は、通過された方にのみメールでご連絡いたします。<br />
                    通常1週間程度お時間をいただいております。
                  </p>
                </div>
              ) : (
                <form onSubmit={handleSubmit} className="contact-form">
                  {/* === 必須項目 === */}
                  <p style={{ fontSize: '12px', color: 'var(--gold)', marginBottom: '2em' }}>
                    <span style={{ color: 'var(--gold)' }}>*</span> は必須項目です
                  </p>

                  <div className="form-group">
                    <label>氏名 <span style={{ color: 'var(--gold)' }}>*</span></label>
                    <input
                      type="text" name="name" value={formData.name}
                      onChange={handleChange} required placeholder="山田 花子"
                    />
                  </div>

                  <div className="form-group">
                    <label>メールアドレス <span style={{ color: 'var(--gold)' }}>*</span></label>
                    <input
                      type="email" name="email" value={formData.email}
                      onChange={handleChange} required placeholder="example@email.com"
                    />
                  </div>

                  <div className="form-group">
                    <label>電話番号 <span style={{ color: 'var(--gold)' }}>*</span></label>
                    <input
                      type="tel" name="phone" value={formData.phone}
                      onChange={handleChange} required placeholder="090-0000-0000"
                    />
                  </div>

                  <div className="form-group">
                    <label>応募ポジション <span style={{ color: 'var(--gold)' }}>*</span></label>
                    <select name="position" value={formData.position} onChange={handleChange} required>
                      <option value="">選択してください</option>
                      {POSITIONS.map((pos) => (
                        <option key={pos.value} value={pos.value} disabled={pos.disabled}>
                          {pos.label}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="form-group">
                    <label>自己紹介（経歴・得意分野） <span style={{ color: 'var(--gold)' }}>*</span></label>
                    <textarea
                      name="introduction" value={formData.introduction}
                      onChange={handleChange} required
                      placeholder={"これまでのご経歴、得意な分野、使用可能なツール等をお書きください。\n\n例:\n・Webデザイナーとして5年勤務後、出産を機に退職\n・Canva / Photoshop / Premiere Proが使えます\n・Instagram運用（企業アカウント）の経験あり"}
                      style={{ minHeight: '200px' }}
                    />
                  </div>

                  <div className="form-group">
                    <label>ポートフォリオURL① <span style={{ color: 'var(--gold)' }}>*</span></label>
                    <input
                      type="url" name="portfolio1" value={formData.portfolio1}
                      onChange={handleChange} required
                      placeholder="https://www.instagram.com/yourname/"
                    />
                    <p style={{ fontSize: '12px', color: 'var(--text-tertiary)', marginTop: '6px' }}>
                      SNSアカウント、Behance、Dribbble、Google Drive等、制作物が確認できるURLをご記入ください。
                    </p>
                  </div>

                  <div className="form-group">
                    <label>ポートフォリオURL②</label>
                    <input
                      type="url" name="portfolio2" value={formData.portfolio2}
                      onChange={handleChange}
                      placeholder="https://..."
                    />
                  </div>

                  <div className="form-group">
                    <label>ポートフォリオURL③</label>
                    <input
                      type="url" name="portfolio3" value={formData.portfolio3}
                      onChange={handleChange}
                      placeholder="https://..."
                    />
                  </div>

                  <div className="form-group">
                    <label>週あたりの稼働可能時間 <span style={{ color: 'var(--gold)' }}>*</span></label>
                    <select name="hoursPerWeek" value={formData.hoursPerWeek} onChange={handleChange} required>
                      <option value="">選択してください</option>
                      {HOURS_OPTIONS.map((opt) => (
                        <option key={opt} value={opt}>{opt}</option>
                      ))}
                    </select>
                  </div>

                  <div className="form-group">
                    <label>稼働開始可能時期 <span style={{ color: 'var(--gold)' }}>*</span></label>
                    <select name="startTiming" value={formData.startTiming} onChange={handleChange} required>
                      <option value="">選択してください</option>
                      {START_OPTIONS.map((opt) => (
                        <option key={opt} value={opt}>{opt}</option>
                      ))}
                    </select>
                  </div>

                  {/* === 任意項目 === */}
                  <div style={{ borderTop: '1px solid var(--gold-border)', margin: '40px 0 30px', paddingTop: '30px' }}>
                    <p style={{ fontSize: '13px', color: 'var(--text-tertiary)', marginBottom: '1.5em' }}>
                      以下は任意項目です（選考には影響しません）
                    </p>
                  </div>

                  <div className="form-group">
                    <label>居住地</label>
                    <select name="prefecture" value={formData.prefecture} onChange={handleChange}>
                      <option value="">選択してください</option>
                      {PREFECTURES.map((pref) => (
                        <option key={pref} value={pref}>{pref}</option>
                      ))}
                    </select>
                  </div>

                  <div className="form-group">
                    <label>当社を知ったきっかけ</label>
                    <select name="referral" value={formData.referral} onChange={handleChange}>
                      <option value="">選択してください</option>
                      {REFERRAL_OPTIONS.map((opt) => (
                        <option key={opt} value={opt}>{opt}</option>
                      ))}
                    </select>
                  </div>

                  <div className="form-group">
                    <label>その他伝えたいこと</label>
                    <textarea
                      name="note" value={formData.note}
                      onChange={handleChange}
                      placeholder="ご質問やアピールしたいことがあればお書きください"
                      style={{ minHeight: '120px' }}
                    />
                  </div>

                  {error && (
                    <p style={{ color: '#e74c3c', fontSize: '14px', marginBottom: '16px' }}>{error}</p>
                  )}

                  <div style={{ textAlign: 'center', marginTop: '40px' }}>
                    <button type="submit" className="btn-primary-custom" disabled={submitting}>
                      {submitting ? '送信中...' : 'エントリーする'}
                    </button>
                  </div>
                </form>
              )}
            </Col>
          </Row>
        </Container>
      </section>
    </div>
  );
}

export default RecruitApplyPage;
